import { useState } from 'react';
import InputConfig from '../InputConfig';
//mui imports====
import { Box } from '@mui/system';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import useStyles from './styles';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import TextField from '@mui/material/TextField';
import Popper from '@mui/material/Popper';
import Autocomplete from '@mui/material/Autocomplete';
//===============
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
	PaperProps: {
		style: {
			maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
			width: 250
		}
	}
};
//keyList is the list of keys to select from, [ NOTE : keyData is the absolute key from rawConfig ], valueType is the type of value input

// This component can be used for both direct values and raw object method, but internally we have used directValue method to update value
const KeyValueInput = ({
	keyList,
	label,
	valueType,
	keyData,
	object, // This props can take rawConfig or directObject as value and can handle both the cases of rawConfig and directValue
	updateObject, // This is a callback function which takes the updated object and updated in rawConfig, it can be used to update rawConfig or directValue input

	isObjectEditor = true,
	isAutoCompleteRequired = false,
	options,
	selectKeyDefaultWidth,
	containerStyle,
	disabled = false
}) => {
	const [keyValueSelected, setKeyValueSelected] = useState('');
	const [value, setValue] = useState(valueType === 'number' ? 0 : '');
	const classes = useStyles();

	/**
	 * @name addKey
	 * @description This function add a new key value pair to the intial object, with two scenarios if isObjectEditor is true or false
	 * 1. true : it updates the object with the rawConfig functionality and passes value to call back function
	 * 2. false : it updates the object value directly and passes it to the callback function
	 */
	const addKey = () => {
		if (disabled) return; // Prevent adding key when disabled
		if (!keyValueSelected) {
			alert('Select a key first!');
			return;
		}
		if (!value) {
			alert('Enter a value first!');
			return;
		}
		const clonedObj = structuredClone(object);
		if (isObjectEditor) {
			clonedObj[keyData + '.' + keyValueSelected] = value;
		} else {
			clonedObj[keyValueSelected] = value;
		}
		updateObject(clonedObj);
		setKeyValueSelected('');
		setValue(valueType === 'number' ? 0 : '');
	};

	/**
	 * @name updateFloorValue
	 * @description This function sets the new value of floor entered by user from InputConfig component
	 * @param updatedValue - It is the updated value returned from InputConfig component.
	 */

	const updateFloorValue = (updatedValue) => {
		if (disabled) return; // Prevent updating value when disabled
		if (valueType === 'number') updatedValue = Number(updatedValue);
		setValue(updatedValue);
	};

	/**
	 * @name handleInputChange
	 * @description This function sets the new value of floor selected by user from Autocomplete component
	 * @param updatedObject - It is the updated object returned from Autocomplete component from which we can extract the floor value.
	 */
	const handleInputChange = (event, updatedObject) => {
		if (disabled) return; // Prevent input change when disabled
		setValue(updatedObject.value);
	};

	const customStyles = {
		transition: 'none',
		width: '250px'
	};

	return (
		<Box
			style={{
				...containerStyle,
				opacity: disabled ? 0.6 : 1
			}}
		>
			<Box>
				<FormControl disabled={disabled}>
					<Select
						value={keyValueSelected}
						label={label}
						MenuProps={MenuProps}
						onChange={(e) => setKeyValueSelected(e.target.value)}
						style={{ width: selectKeyDefaultWidth || 'auto' }}
						disabled={disabled}
					>
						{keyList.map((keyItem) => {
							const label = typeof keyItem === 'string' ? keyItem : keyItem.label;
							const value = typeof keyItem === 'string' ? keyItem : keyItem.value;
							return (
								<MenuItem key={value} value={value}>
									{label}
								</MenuItem>
							);
						})}
					</Select>
				</FormControl>
			</Box>
			<Box>
				{/* AutoComplete Component will be disaplyed if isAutoCompleteRequired flag is true  */}
				{isAutoCompleteRequired && (
					<Autocomplete
						disabled={disabled}
						value={value}
						onChange={handleInputChange}
						id="number-input"
						freeSolo={false}
						options={options}
						sx={{ width: 250 }}
						style={{ margin: '1rem 0' }}
						PopperComponent={(props) => <Popper {...props} style={customStyles} />}
						renderInput={(params) => <TextField {...params} label="Select" variant="outlined" />}
					/>
				)}
				{/* InputConfig component with direct value updating functionality will be displayed, if isAutoCompleteRequired flag is false */}
				{!isAutoCompleteRequired && (
					<InputConfig
						editable={!disabled}
						inputType={valueType}
						inputStyles={{ width: '100%', margin: '1rem 0' }}
						isObjectEditor={false}
						directValue={value}
						updateDirectValue={(value) => {
							updateFloorValue(value);
						}}
					/>
				)}
			</Box>

			<AddCircleOutlineOutlinedIcon
				color="primary"
				fontSize="large"
				className={classes.icon}
				onClick={addKey}
				style={{
					opacity: disabled ? 0.5 : 1,
					cursor: disabled ? 'not-allowed' : 'pointer'
				}}
			/>
		</Box>
	);
};

export default KeyValueInput;
